import 'angularjs-gauge';

const gaugeBuilderComponent = {
  template: require('./gauge-builder.html'),
  restrict: 'E',
  controller: GaugeBuilderController,
  controllerAs: 'vm',
  bindings: {
    iid: '<',
    value: '<',
    uom: '<',
    state: '<',
    orientation: '<',
    name: '<',
    sparklines: '<',
    min: '<',
    max: '<',
    type: '<',
    size: '<',
    minThreshold: '<',
    maxThreshold: '<',
    showMinMax: '<',
    alarming: '<'
  }
};

function GaugeBuilderController() {
  'ngInject';

  let vm = this;
  vm.getDialHeight = getDialHeight;
  vm.getSparkLineHeight = getSparkLineHeight;
  vm.getSparkLineWidth = getSparkLineWidth;
  vm.disabled = true;
  vm.foregroundColor = foregroundColor(null);
  vm.backgroundColor = backgroundColor(null);

  vm.$onChanges = function(changes) {
    if (changes.value && changes.value.currentValue) {
      vm.value = parseFloat(vm.value.toFixed(vm.decimal));
      vm.disabled = disabled(vm.value);
      vm.foregroundColor = foregroundColor(vm.value, vm.alarming);
      vm.backgroundColor = backgroundColor(vm.value);
    }
  };

  function getDialHeight(size) {
    if (size === 'large') {
      return 500;
    } else if (size === 'medium') {
      return 300;
    } else if (size === 'small') {
      return 175;
    } else {
      return 150;
    }
  }

  function getSparkLineHeight(size) {
    if (size === 'large') {
      return 60;
    } else if (size === 'medium') {
      return 30;
    } else if (size === 'small') {
      return 15;
    }

    return 10;
  }

  function getSparkLineWidth(size) {
    if (size === 'large') {
      return 150;
    } else if (size === 'medium') {
      return 100;
    } else if (size === 'small') {
      return 60;
    }

    return 45;
  }

  function disabled(value) {
    return value === null || value === undefined;
  }

  function foregroundColor(value, alarming) {
    const color = disabled(value) ? 'rgba(173,173,173,0)' : 'rgb(25,144,191)';
    return alarming ? 'rgb(255, 4, 2)' : color;
  }

  function backgroundColor(value) {
    return disabled(value) ? 'rgba(173,173,173,0.5)' : 'rgb(173,173,173)';
  }
}

export default gaugeBuilderComponent;
